import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';

export const PAGE_TITLE_SUFFIX = ' - EY Trade Connect 2.0';

export const resolveTitleForParam = (paramName: string): ResolveFn<string> => {
  return (route: ActivatedRouteSnapshot): Observable<string> | string => {
    const paramValue = route.paramMap.get(paramName);
    return paramValue ? `${paramValue}${PAGE_TITLE_SUFFIX}` : `Untitled${PAGE_TITLE_SUFFIX}`;
  };
};
